import logo from './img/loyalty_logo.svg';
import './App.css';
import config from './config.js';
import {useState} from 'react';
import Confetti from 'react-confetti';
import Swal from 'sweetalert2';
import "bootstrap/dist/css/bootstrap.min.css"


function App() {
    const [unicorn, setUnicorn] = useState(false);
    unicorn && Swal.fire('<p style=\'margin: 0px;font-size: 18vh;\'>&#x1F984;</p><span style=\'background-image: linear-gradient(to left, ' +
        'darkviolet, '+
        'indigo, ' +
        'blue, ' +
        'turquoise, '+
        'green, ' +
        'yellow, ' +
        'orange, ' +
        'red);' +
        '-webkit-background-clip: text;' +
        '-webkit-text-fill-color: transparent;\'>Congratulations, you found the unicorn!</span>', 'Unicorns are shy and timid creatures. Most humans never see a single unicorn in their entire life. Consider yourself privileged!');
    console.log(JSON.stringify(config));

    return (
        <div className="App">
            <header className="App-header">
                <img src={logo} className={'App-logo'} alt="logo"/>
            </header>
            <section className={'d-flex justify-content-center'}>
                <div className={'border border-1 rounded-3 container-sm ps-5'}>
                    <embed className={'embed-field'}
                           src={`https://${config.includeUrl}/html/register-embed.html?restUrl=https://${config.restUrl}&restPort=${config.restPort}&integrationBaseUrl=https://${window.location.origin}`}/>
                </div>
            </section>
            <footer className={'App-footer my-2'}>
                <small>
                    {unicorn ?
                        <span onClick={() => (setUnicorn(!unicorn))}>&#x1F984;</span> :
                        <span onClick={() => (setUnicorn(!unicorn))}>&copy;</span>
                    }
                    {new Date().getFullYear()}
                    <a href={'https://www.innocardloyalty.ch'}>Innocard Loyalty AG</a>
                </small>
            </footer>

            {
                unicorn && <Confetti
                    numberOfPieces={window.innerWidth}
                    gravity={0.1}
                    recycle={false}
                    tweenDuration={50000}
                    colors={['#C1D881', '#396E6B', '#7EC3C2','#146869','#7fb568']}
                />
            }

        </div>
    )
        ;
}

export default App;
